<!-- 
/**
    * -----------------------------------------------------------------------------
    * This program is developed by Tenwave Infotech Pvt. Ltd.
    * 
    * Copyright © 2024 Tenwave Infotech Pvt. Ltd. All rights reserved.
    * 
    * Contact: Email us at contact@tenwaveinfotech.com or visit www.tenwavehealthcare.com
    * 
    * ----------------------------------------------------------------------------- 
**/
-->

<template>
    <div class="d-flex flex-column align-items-start">
        <span v-if="fileName" class="mb-1 text-success">
            {{ fileName }}
        </span>
        <div class="btn btn-sm btn-file mb-1">
            <input type="file" @change="changeFile($event)" v-bind:name="keyName" v-bind:id="keyName" class="form-control">
            <span>Browse …</span>
        </div>
        <small class="text-muted fw-semibold" v-if="supported_type">
            Supported format: (pdf, docx, doc, jpg, png, gif, jpeg, rtx, txt,
            ppt, pptx, xls, xlsx, numbers, ods)
        </small>
        <span class="text-danger">{{file_error}}</span>
    </div>
</template>
<script>
    export default {
        name: "select-file",
        props: {
            keyName: String,
            obj: Object,
            supported_type:true
        },
        data() {
            return {
                fileName:'',
                file_error:''
            }
        },
        mounted() {
        },
        methods: {
            changeFile(e) {
                const self = this;
                self.file_error = '';
                const fileInput = e.target;
                const file = fileInput.files[0];

                if (!file) {
                    return;
                }

                // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (file.name.length > MAX_FILE_NAME_LENGTH) {
                    self.file_error = `File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;

                    // Clear selected file
                    fileInput.value = '';

                    // Clear previous values
                    self.obj[self.keyName] = '';
                    self.obj[self.keyName + '_name'] = '';
                    self.fileName = '';

                    return;
                }

                self.file_error = '';

                const reader = new FileReader();

                reader.onload = function (e) {
                    self.obj[self.keyName] = e.target.result;
                };

                reader.readAsDataURL(file);

                self.obj[self.keyName + '_name'] = file.name;
                self.fileName = file.name;
            },
        }
    }
</script>